const readStatusFromObject = (value: unknown): number | null => {
    if (!value || typeof value !== 'object') {
        return null;
    }

    const candidate = value as {
        status?: unknown;
        statusCode?: unknown;
        data?: { status?: unknown; title?: unknown };
    };

    if (typeof candidate.status === 'number') {
        return candidate.status;
    }

    if (typeof candidate.status === 'string') {
        const parsed = parseInt(candidate.status, 10);
        if (!Number.isNaN(parsed)) {
            return parsed;
        }
    }

    if (typeof candidate.statusCode === 'number') {
        return candidate.statusCode;
    }

    if (candidate.data && typeof candidate.data.status === 'number') {
        return candidate.data.status;
    }

    if (candidate.data && typeof candidate.data.status === 'string') {
        const parsed = parseInt(String(candidate.data.status), 10);
        if (!Number.isNaN(parsed)) {
            return parsed;
        }
    }

    return null;
};

/** Works with axios 0.18 and globalAxios rejecting the raw response object. */
export const readHttpErrorStatus = (error: unknown): number | null => {
    if (error && typeof error === 'object') {
        const err = error as { response?: unknown };
        if (err.response) {
            const fromResponse = readStatusFromObject(err.response);
            if (fromResponse != null) {
                return fromResponse;
            }
        }
    }

    return readStatusFromObject(error);
};

export const isHttpNotFound = (error: unknown): boolean => readHttpErrorStatus(error) === 404;

export const isActiveOrderMissingError = (error: unknown): boolean => {
    const status = readHttpErrorStatus(error);
    return status === 404 || status === 500;
};
